import { render, staticRenderFns } from "./RecruitIndex.vue?vue&type=template&id=506b1501&scoped=true"
import script from "./RecruitIndex.vue?vue&type=script&lang=js"
export * from "./RecruitIndex.vue?vue&type=script&lang=js"
import style0 from "./RecruitIndex.vue?vue&type=style&index=0&id=506b1501&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b1501",
  null
  
)

export default component.exports